import functions from '../functions';
import { list } from './list';

$(() => {
    listTravel.init();
});

const listTravel = {
    $form: null,
    form: null,
    $filter: null,
    filter: null,
    defaults: {
        _page: 1,
        perPage: 12,
        language: functions.getLang(),
        arrivalDateFrom: '',
        destination: '',
        countryId: '',
        objectGroupId: 6,
        //guests: '',
        hasArrival: 2,
        transportationType: null,
    },
    params: {},
    isHome: false,
    $listItems: null,
    mainFields: ['arrivalDateFrom', 'destination', 'sortBy', '_page'],
    init() {
        this.$form = $('.search-form.search-travel').last();
        this.form = this.$form[0];

        if(! this.form) {
            return;
        }

        this.$listItems = $('.list-items');
        this.isHome = this.$form.attr('data-ishome') || ! this.$listItems.length;

        this.setDefaults();

        this.$form.on('submit', e => {
            e.preventDefault();
            const $target = $(e.target);
            this.getFormData($target);
            this.params = functions.getDataForUrl(this.params);

            if(this.isHome) {
                if (this.defaults.tagCategoryId) {
                    this.params.tagCategoryId = this.defaults.tagCategoryId;
                }
                location = $target.attr('data-listurl') + '#' + $.param(this.params);
            } else {
                functions.setUrlData(this.params, true, true);
            }
        });

        if(! this.isHome) {
            this.getParams();
            functions.setFormData(this.form, this.params);
            this.find();
        }

        $('.ms-clear').on('click', e => {
            e.preventDefault();
            e.stopPropagation();
            this.params.destination = '';
            $(this.form.destination).val('').trigger('change');
        });

        $('[name="tagCategoryId"]').on('change', e => {
            this.getParams();
            this.setTagCategoryId();
            this.params._page = 1;
            functions.setUrlData(this.params, true, true);
        });

        $(window).on('hashchange', e => {
            this.getParams();
            this.setTagCategoryId();

            functions.scrollToElement(this.$listItems, 100);
            this.find();
        });
    },
    setDefaults() {
        this.defaults.objectGroupId = this.$form.attr('data-objectgroupid');
        this.defaults.objectTypeId = this.$form.attr('data-objecttypeid');
        this.defaults.transportationType = this.$form.attr('data-transportationType');
        this.defaults.sortBy = this.$form.attr('data-sortBy');

        this.defaults.countryId = this.$form.attr('data-countryid');
        this.defaults.destination = this.$form.attr('data-destination');
        this.defaults.destination = this.defaults.destination ? this.defaults.destination : this.defaults.countryId;

        this.defaults.tagCategoryId = this.$form.attr('data-tagcategoryid');
        if (this.$form.attr('data-partnerid')) {
            this.defaults.partnerId = this.$form.attr('data-partnerid');
        }
    },
    getFormData($form) {
        this.params = functions.getFormData($form);
    },
    getParams() {
        this.params = list.getParams(this.params, {});
        //this.params = list.getParams(this.params, this.defaults, this.filterParams);
    },
    setTagCategoryId() {
        if($('[name="tagCategoryId"]').length) {
            let tagCategoryIds = [];
            $('[name="tagCategoryId"]').each((index, target) => {
                const $target = $(target);
                if($target[0].checked) {
                    tagCategoryIds.push($target.attr('data-value'));
                }
            });
            this.params.tagCategoryId = tagCategoryIds.join(",");
        }
    },
    find() {
        list.query = $.extend({}, this.defaults, this.params);
        list.params = this.params;
        list.find().then((response) => {
            list.findDone(response);
            // LOZAD
            window.observer.observe();
        });
    },

};